import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Navbar from './components/Navbar';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import Dashboard from './pages/Dashboard';
import CreateQRCode from './pages/CreateQRCode';
import EditQRCode from './pages/EditQRCode';
import QRCodeDetail from './pages/QRCodeDetail';
import QRCodeList from './pages/QRCodeList';
import Analytics from './pages/Analytics';
import Billing from './pages/Billing';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/qr-codes"
              element={
                <PrivateRoute>
                  <QRCodeList />
                </PrivateRoute>
              }
            />
            <Route
              path="/qr-codes/create"
              element={
                <PrivateRoute>
                  <CreateQRCode />
                </PrivateRoute>
              }
            />
            <Route
              path="/qr-codes/view/:id"
              element={
                <PrivateRoute>
                  <QRCodeDetail />
                </PrivateRoute>
              }
            />
            <Route
              path="/qr-codes/edit/:id"
              element={
                <PrivateRoute>
                  <EditQRCode />
                </PrivateRoute>
              }
            />
            <Route
              path="/analytics"
              element={
                <PrivateRoute>
                  <Analytics />
                </PrivateRoute>
              }
            />
            <Route
              path="/analytics/:qrId"
              element={
                <PrivateRoute>
                  <Analytics />
                </PrivateRoute>
              }
            />
            <Route
              path="/billing"
              element={
                <PrivateRoute>
                  <Billing />
                </PrivateRoute>
              }
            />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
